'use client';

import React, { useEffect, useRef } from 'react';

const CursorSpotlight: React.FC = () => {
  const spotlightRef = useRef<HTMLDivElement>(null);
  const cursorRef = useRef<HTMLDivElement>(null);
  const posRef = useRef({ x: -999, y: -999 });
  const rafRef = useRef<number>(0);

  useEffect(() => {
    const onMove = (e: MouseEvent) => {
      posRef.current = { x: e.clientX, y: e.clientY };
    };

    const animate = () => {
      if (spotlightRef.current) {
        spotlightRef.current.style.left = `${posRef.current.x}px`;
        spotlightRef.current.style.top = `${posRef.current.y}px`;
      }
      if (cursorRef.current) {
        cursorRef.current.style.left = `${posRef.current.x}px`;
        cursorRef.current.style.top = `${posRef.current.y}px`;
      }
      rafRef.current = requestAnimationFrame(animate);
    };

    const onEnterInteractive = () => {
      cursorRef.current?.classList.add('hovering');
    };
    const onLeaveInteractive = () => {
      cursorRef.current?.classList.remove('hovering');
    };

    document.addEventListener('mousemove', onMove, { passive: true });
    rafRef.current = requestAnimationFrame(animate);

    const interactives = document.querySelectorAll('a, button, [role="button"], input, textarea, select');
    interactives.forEach((el) => {
      el.addEventListener('mouseenter', onEnterInteractive);
      el.addEventListener('mouseleave', onLeaveInteractive);
    });

    return () => {
      document.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(rafRef.current);
      interactives.forEach((el) => {
        el.removeEventListener('mouseenter', onEnterInteractive);
        el.removeEventListener('mouseleave', onLeaveInteractive);
      });
    };
  }, []);

  return (
    <>
      {/* Spotlight glow */}
      <div
        ref={spotlightRef}
        className="spotlight"
        aria-hidden="true"
      />
      {/* Custom cursor dot */}
      <div
        ref={cursorRef}
        className="custom-cursor"
        aria-hidden="true"
      />
    </>
  );
};

export default CursorSpotlight;